/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import type { MenuProps } from "antd";
import { Button, Dropdown, Image } from "antd";
import { ReactComponent as RefreshIcon } from "assets/common/icons/refresh.svg";
import Logo from "assets/common/logo.png";
import logoutIcon from "assets/common/logoutIcon.png";
import mailIcon from "assets/common/mailIcon.png";
import { ModalIconChervonDown } from "assets/common/modal";
import Support from "assets/common/support.png";
import VietNam from "assets/common/VietNam.png";
import Loading from "components/common/Loading";
import AutoTime from "components/mobile/Sidebar/AutoTime";
import { PATH } from "constants/path";
import { ModalTypeValue } from "enums/modalType";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useAppLogout } from "hooks/useLogout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { selectIsAuthenticated, selectUsername } from "store/auth";
import { setOpenModal } from "store/master";
import { selectBalance, selectProfile, selectProfileLoading } from "store/user";
import { getMemberBalance } from "store/user/user.thunk";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

import { HeaderStyle } from "./index.style";

const styleLabelMenu = { fontSize: "12px" };

export const listMenuProfileHeader: MenuProps["items"] = [
  {
    key: "history",
    label: <li style={{ ...styleLabelMenu }}>Lịch sử đặt cược</li>,
  },
  {
    key: "transaction",
    label: <li style={styleLabelMenu}>Chi tiết giao dịch</li>,
  },
  {
    key: "change-password",
    label: <li style={styleLabelMenu}>Đổi mật khẩu rút tiền</li>,
  },
  {
    key: "member-center",
    label: <li style={styleLabelMenu}>Trung tâm hội viên</li>,
  },
  {
    key: "logout",
    label: (
      <div
        css={css`
          position: relative;
        `}
      >
        <span style={styleLabelMenu}>Đăng xuất</span>
        <div
          css={css`
            background: url(${logoutIcon});
            height: 13px;
            width: 13px;
            position: absolute;
            top: 6px;
            left: -21px;
          `}
        />
      </div>
    ),
  },
];

export const Header = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handleLogout = useAppLogout();

  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const profile = useAppSelector(selectProfile);
  const balanceMember = useAppSelector(selectBalance);
  const isLoading = useAppSelector(selectProfileLoading);
  const username = useAppSelector(selectUsername);

  const [isLoadingPoints, setIsLoadingPoints] = useState<boolean>(false);

  const onClickMenu = (key: string) => {
    switch (key) {
      case "logout":
        handleLogout();
        break;
      case "history":
        navigate(PATH.User.BettingHistory);
        break;
      case "transaction":
        navigate(PATH.User.Transactions);
        break;
      case "member-center":
        navigate(PATH.User.SecuritySetting);
        break;
      case "change-password":
        navigate(`${PATH.User.changePasswordWithdraw}`);
        break;
      default:
        break;
    }
  };

  return (
    <div
      css={css`
        height: 90px;
        background: black;
        min-width: 1480px;
        padding: 0 212.5px;
        ${media.xxl} {
          width: 100%;
          min-width: unset;

          padding: 0 60px;
        }
      `}
    >
      <div
        css={css`
          height: 100%;
          margin-left: auto;
          margin-right: auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        <div
          css={css`
            display: flex;
            height: 100%;
            align-items: center;
            gap: 15px;
          `}
        >
          <Image
            src={Logo}
            alt=""
            preview={false}
            height={120}
            style={{
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          />
        </div>

        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 10px;
          `}
        >
          {isLoading ? (
            <Loading center width={600} height={35} fontSize={21} />
          ) : (
            <>
              {isAuthenticated ? (
                <>
                  <div
                    css={css`
                      display: flex;
                      align-items: center;
                      gap: 20px;
                      margin-right: 20px;
                      font-size: 14px;
                      color: white;
                    `}
                  >
                    <div
                      css={css`
                        display: flex;
                        align-items: center;
                        gap: 4px;
                      `}
                    >
                      <p>Xin chào: {profile?.username}</p>
                      <div
                        css={css`
                          width: 24px;
                          height: 24px;
                          text-decoration: none;
                          position: relative;
                          bottom: -2px;
                          cursor: pointer;
                          background: url(${mailIcon});
                        `}
                        onClick={() => {
                          navigate(PATH.User.InternalMail);
                        }}
                      />
                    </div>
                    <div
                      css={css`
                        display: flex;
                        align-items: center;
                        gap: 4px;
                      `}
                    >
                      <p>Ví tài Khoản: {balanceMember?.total || 0} </p>
                      <RefreshIcon
                        onClick={async () => {
                          if (!profile?.username) return;
                          setIsLoadingPoints(true);
                          await dispatch(
                            getMemberBalance({ username: username }),
                          );
                          setIsLoadingPoints(false);
                        }}
                        data-loading={isLoadingPoints ? "loading" : ""}
                        css={HeaderStyle.iconRefresh}
                      />
                    </div>
                  </div>

                  <div
                    css={css`
                      display: flex;
                      align-items: center;
                      gap: 10px;
                    `}
                  >
                    <Button
                      css={css`
                        min-width: 150px;
                        height: 28px;
                        color: white;
                        border-color: transparent;
                        border-radius: 8px;
                        background-color: ${theme.colors.gradient[50]};
                        font-size: 12px;

                        :hover {
                          color: white !important;
                          border-color: transparent !important;
                        }
                      `}
                      onClick={() => navigate(PATH.User.Deposit)}
                    >
                      Nạp tiền trực tuyến
                    </Button>
                    <Button
                      css={css`
                        min-width: 150px;
                        height: 28px;
                        color: white;
                        border-radius: 8px;
                        background-color: ${theme.colors.gradient[50]};
                        border-color: transparent;
                        font-size: 12px;

                        :hover {
                          color: white !important;
                          border-color: transparent !important;
                        }
                      `}
                      onClick={() => navigate(PATH.User.Withdraw)}
                    >
                      Rút tiền trực tuyến
                    </Button>

                    <Dropdown
                      menu={{
                        items: listMenuProfileHeader,
                        triggerSubMenuAction: "click",
                        style: {
                          width: "180px",
                          listStyle: "outside",
                          paddingLeft: "20px",
                        },
                        onClick: (e) => {
                          onClickMenu(e.key);
                        },
                      }}
                      trigger={["click"]}
                      placement="bottomRight"
                    >
                      <Button
                        css={css`
                          height: 28px;
                          width: 28px;
                          color: white;
                          font-size: 14px;
                          font-weight: bold;
                          border: 1px solid white;
                          background-color: transparent;
                          border-radius: 8px;

                          :hover {
                            border-color: white !important;
                          }
                        `}
                      >
                        <Image
                          src={ModalIconChervonDown}
                          alt=""
                          height={7}
                          width={10}
                          preview={false}
                        />
                      </Button>
                    </Dropdown>
                  </div>
                </>
              ) : (
                <>
                  <Button
                    css={HeaderStyle.button}
                    onClick={() => dispatch(setOpenModal(ModalTypeValue.LOGIN))}
                  >
                    Đăng nhập
                  </Button>
                  <Button
                    css={HeaderStyle.button}
                    style={{
                      position: "relative",
                    }}
                    onClick={() =>
                      dispatch(setOpenModal(ModalTypeValue.REGISTER))
                    }
                  >
                    Đăng ký
                    <div
                      css={css`
                        position: absolute;
                        bottom: -22px;
                        font-size: 12px;
                        font-weight: 400;
                      `}
                    >
                      <AutoTime />
                    </div>
                  </Button>
                </>
              )}
            </>
          )}

          <div
            css={css`
              display: flex;
              align-items: center;
              gap: 4px;
            `}
          >
            <Image
              src={VietNam}
              alt=""
              height={35}
              width={35}
              preview={false}
            />
            <div
              css={css`
                position: relative;
                cursor: pointer;
              `}
              onClick={() => {
                window.open(
                  "https://acv188.win/",
                  "Support",
                  `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
                  width=600,height=400,left=100,top=100`,
                );
              }}
            >
              <Image
                src={Support}
                alt=""
                height={35}
                width={35}
                preview={false}
              />
              <div css={HeaderStyle.support}>Bạn cần hỗ trợ gì ?</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
